var buildHeaders = function buildHeaders() {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json');
  return headers;
};
/**
 * @param {string} serviceUrl - GraphQL service endpoint
 * @param {Query} query - GraphQL query
 */
export function graphqlQuery(serviceUrl, query) {
  var headers = buildHeaders();
  return fetch(new Request("".concat(serviceUrl), {
    method: 'POST',
    credentials: 'include',
    mode: 'cors',
    headers: headers,
    body: JSON.stringify(query)
  })).then(function (response) {
    if (!response.ok) {
      return Promise.reject({
        code: response.status,
        reason: response.statusText
      });
    }
    return response;
  }).then(function (response) {
    return response.json();
  }).then(function (json) {
    if (json.errors) {
      var _json$errors$;
      return Promise.reject({
        reason: ((_json$errors$ = json.errors[0]) === null || _json$errors$ === void 0 ? void 0 : _json$errors$.category) || 'default'
      });
    }
    return json.data;
  });
}